import { useQuery } from '@tanstack/react-query';
import { useApiWebLegacy } from '@/shared/api';
import { plantOperationQueryOptions } from './plant-operation.query-options';

/**
 * 발전소 운영 스냅샷(누적 발전량·운영기간) query — 대시보드 단일 스코프 전용. 2.0 web-legacy
 * (`useApiWebLegacy`). `energy` 미확보 시 미발화 → `data` undefined(화면은 '-').
 */
export function usePlantOperationQuery(plantId: string | undefined, energy: string | undefined) {
  const api = useApiWebLegacy();
  return useQuery(plantOperationQueryOptions(api, plantId, energy));
}
